import { Injectable } from 'angular-ts-decorators';

import { Domain } from './domain';
import type { IConfig } from './config';

export type SpynlVersions = {
  [key in 'spynl_app' | 'spynl_data']: {
    version: string;
    commit: string;
    scmVersion: string;
  };
};

export type AboutResponse = {
  versions: SpynlVersions;
  version: string;
  language: string;
  message: string;
  status: string;
  time: string;
};

/**
 * Service to query /about endpoints of spynl
 */
@Injectable('about')
export class About {
  private spynlUrl: string;
  constructor(
    private $http: ng.IHttpService,
    private $q: ng.IQService,
    config: IConfig,
    domain: Domain,
  ) {
    'ngInject';

    this.spynlUrl = '//' + domain.sibling(config.spynlSubdomain);
  }

  /**
   *
   * Queries the /about endpoint
   * @returns {promise}
   * $http promise that resolve with about me response
   */
  get(): ng.IPromise<AboutResponse> {
    let url = this.spynlUrl + '/about';

    return this.$http.get(url).then(
      (response) => {
        return <AboutResponse>response.data;
        // TODO CORE-440 move error to catch
      },
      (error) => this.$q.reject(error.data.message),
    );
  }

  /**
   *
   * Queries the /about/version endpoint
   * @returns {promise}
   * $http promise that resolve with about me response
   */
  versions(): ng.IPromise<SpynlVersions> {
    let url = this.spynlUrl + '/about/versions';

    return this.$http
      .get(url, {
        // done on config level for v7; setting for v6
        withCredentials: true,
      })
      .then(
        (response) => {
          return <SpynlVersions>response.data;
          // TODO CORE-440 move error to catch
        },
        (error) => this.$q.reject(error.data.message),
      );
  }
}
